import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/modules/shared.module';
import { CustomTimelineChartComponent } from './custom-timeline-chart.component';
import { NgxGanttModule } from '@worktile/gantt';

@NgModule({
    declarations: [ CustomTimelineChartComponent ],
    imports: [ SharedModule, NgxGanttModule ],
    exports: [ CustomTimelineChartComponent ],
    providers: [],
})
export class CustomTimelineChartModule {}